import React, { useState, useEffect } from "react";
import "./HistorySection.css";
import IconTalk from "../../common/icons/IconTalk";
import { FaEllipsisV } from "react-icons/fa";
import AlertModal from "../alert/AlertModal";

const HistorySection = ({
  scope,
  descusion,
  handleSend,
  currentConversationId,
  handleDelete,
}) => {
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const toggleDropdown = (id) => {
    // If the clicked menu is already open, close it. Otherwise, open it and close others.
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const closeDropdown = () => {
    setOpenDropdownId(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".options-menu")) {
        closeDropdown();
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowAlert(true);
  };

  const handleDeleteConfirmed = () => {
    if (!deleteId) return;
    handleDelete(deleteId);
    setShowAlert(false);
  };

  return (
    <div className="history-section">
      <h3>{scope}</h3>
      <ul>
        {descusion.map(({ id, title }, index) => (
          <li
            className={`question ${
              id === currentConversationId ? "active" : ""
            }`}
            key={index}
            onClick={() => handleSend(id)} // This will only trigger when clicking the <li>
          >
            <div className="icon-wrapper">
              {id === currentConversationId && (
                <span className="active-dot"></span>
              )}
              <IconTalk className="chat-icon" />
            </div>
            <p>{title}</p>
            <div className="options-menu">
              <FaEllipsisV
                className="options-icon"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent event bubbling to the <li>
                  toggleDropdown(id);
                }}
              />
              {openDropdownId === id && (
                <div className="dropdown">
                  <button
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent event bubbling to the <li>
                      confirmDelete(id);
                    }}
                  >
                    Supprimer
                  </button>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>

      <AlertModal
        message="Êtes-vous sûr de vouloir supprimer cette discussion ?"
        onConfirm={handleDeleteConfirmed}
        onCancel={() => setShowAlert(false)}
        isOpen={showAlert}
        confirmText="Oui, supprimer"
        cancelText="Annuler"
      />
    </div>
  );
};

export default HistorySection;
